import React, { useContext, useEffect, useState } from "react"
import { Modal, Form } from "react-bootstrap";
import CustomSelect from "../constant/customselect";
import CustomButton from "../component/button";
import { retry } from "@reduxjs/toolkit/query";
import filterApplicant from "../constant/advanceFilter";
import { toastMsg } from "../component/toast";
import { PostCallWithErrorResponse, simpleGetCall, simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig } from "../Api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { optionsSalary } from "../constant/optionSalary";
import { Tooltip } from "antd";
import { educationOptions } from "../constant/educationOpt";
import { personalityTypes } from "../constant/jobType";
import cross from '../assets/images/cross1.svg'
import { personaloities } from "../constant/personaloities";
import clear from "../assets/images/claear.svg"

const options = [
    { label: "Greater Than", value: "Greater Than" },
    { label: "Less Than", value: "Less Than" },
    { label: "Between", value: "Between" }
]

const AdvanceFilter = (props) => {

    const { adminData } = useContext(AppContext)

    const [filterName, setFilterName] = useState('')


    const {
        applicatnts,
        show,
        customQuestion,
        setAccessCoeList,
        setShowAdvanceFilter,
        setIsFilter,
        isClearFilters,
        setIsClearFilters,
        setFilteredInfo,
        code,
        setFilteredData,
        allData

    } = props

    const initialState = {
        id: 0,
        filterName: '',
        personalityMatch: [],
        profileMatch: [],
        educationLevel: [],
        educationArea: [],
        industry: [],
        currentTitle: [],
        experience: "",
        expAbo: "",
        expBel: '',
        exprienceIn: 'Between',
        prmeryIn: 'Between',
        secnIn: 'Between',
        departments: [],
        availDateBef: '',
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        question6: '',
        graph1: [],
        graph2: [],
        graph3: [],
        primaryPersonlity: "",
        primaryPerAbo: '',
        primaryPErBel: '',
        secoundryPersonlity: '',
        secoundryPersonlityAbo: '',
        secoundryPersonlityBel: '',
        quizScore: [],
        expectedSal: []

    }

    const dropDownsDetails = {
        personalities: [],
        profiles: [],
        educationLevels: [],
        eductionArea: [],
        industries: [],
        departments: [],
        quizScores: [],
        graph1: [],
        graph2: [],
        graph3: [],
        titleList: [],
        salOpt: []

    }

    const [filters, setFilters] = useState(initialState)
    const [isAddFilter, setISAddFilter] = useState(false)
    const [dropdownData, setDropDownData] = useState(dropDownsDetails)
    const [filterList, stFilterList] = useState([])
    const [searchTermsVal, setsearchTermsVal] = useState({
        educationAreaVal: '',
        currentTitleVal: ''
    })

    const handleChange = (key, val) => {

        setFilters(prev => ({
            ...prev,
            [key]: val
        }))

    }

    const clearFilters = () => {
        setAccessCoeList(allData)
        setFilters(initialState)
        setShowAdvanceFilter(false)
        setFilteredInfo({})
    }


    useEffect(() => {

        if (isClearFilters) {
            clearFilters()
            setIsClearFilters(false)
        }

    }, [isClearFilters])

    useEffect(() => {
        getDropDownData()
        getFilters()

    }, [show])

    useEffect(() => {
        getAllIndustryList()
        getAllspecialization()
        getDepartmentList()
    }, [])






    const getDropDownData = () => {
        const makeOptions = (arr) =>
            [...new Set(arr.filter(Boolean))].map((val) => ({
                label: val,
                value: val,
            }));

        const personalities = makeOptions(applicatnts.map((a) => a?.personalityMatch));
        const profiles = makeOptions(applicatnts.map((a) => a?.applicationMatch));
        const educationLevels = makeOptions(applicatnts.map((a) => a?.educationLevel));


        const quizScores = makeOptions(applicatnts.map((a) => a?.quizScore));
        const graph1 = makeOptions(applicatnts.map((a) => a?.profile_1));
        const graph2 = makeOptions(applicatnts.map((a) => a?.profile_2));
        const graph3 = makeOptions(applicatnts.map((a) => a?.profile_3));
        const titleList = makeOptions(applicatnts.map((a) => a?.roleName));
        const salOpt = makeOptions(applicatnts.map((a) => a?.expectedCTC));
        setDropDownData(prev => ({
            ...prev,
            personalities,
            profiles,
            educationLevels,
            quizScores,
            graph1,
            graph2,
            graph3,
            titleList,
            salOpt
        }));
    };


    const getDepartmentList = () => {
        simpleGetCall(ApiConfig.GET_DEPARTMENT_LIST)
            .then((res) => {
                if (res.succeded) {
                    setDropDownData(prev => ({
                        ...prev,
                        departments: res?.response
                    }))
                }
            })


    }

    const getAllIndustryList = () => {
        simpleGetCall(ApiConfig.GET_INDUSTRY_LIST)
            .then((res) => {
                if (res.succeded) {
                    setDropDownData(prev => ({
                        ...prev,
                        industries: res?.response
                    }))
                }
            })
            .catch((err) => console.log(err));
    };

    const getAllspecialization = () => {
        simpleGetCall(ApiConfig.GET_AREA_OF_EDUCATION)
            .then((res) => {
                if (res.succeded) {
                    setDropDownData(prev => ({
                        ...prev,
                        eductionArea: res?.response
                    }));
                }
            })

    };

    const handleSaveFilter = (isNew = true) => {

        if (filterName?.length < 3) {
            toastMsg('error', 'Please Enter Filter Name At Least 3 Words')
            return
        }

        let data = {}

        if (isNew) {
            data.id = 0
        } else {
            data.id = filters?.id
        }

        data.email = adminData?.email
        data.code = code
        data.filterJson = JSON.stringify(filters)
        data.filterName = filterName

        PostCallWithErrorResponse(ApiConfig.SAVE_ADVANCE_FILTER, data).then((res) => {

            if (res?.json?.succeded) {
                toastMsg('success', res?.json?.response?.statusMessage)
                setISAddFilter(false)
                setFilterName('')
                getFilters()
            } else {
                toastMsg('error', res?.json?.response?.statusMessage)
            }

        })

    }

    const handleKeyDown = (e, type = '', valType) => {
        if ((e.key === "Enter" || e.key === "Tab" || e.key === ",") && searchTermsVal[valType].trim() !== "") {
            e.preventDefault();



            setFilters(prev => ({
                ...prev,
                [type]: [...prev[type], searchTermsVal[valType].trim()]
            }))

            setsearchTermsVal(prev => ({
                ...prev,
                [valType]: ''
            }))

        }
    };


    const handleRemove = (index, key) => {

        let filteOut = filters[key]

        filteOut = filteOut.filter((_, i) => i != index)

        setFilters(prev => ({
            ...prev,
            [key]: filteOut
        }))

    }

    const getFilters = () => {

        simpleGetCallWithErrorResponse(ApiConfig.GET_FILTERS_LIST + `?Code=${code}&EmailId=${adminData?.email}`).then((res) => {


            if (res?.json?.succeded) {
                let option = res?.json?.response?.map((i) => ({
                    label: i?.filterName,
                    value: i?.id,
                    details: i
                }))


                stFilterList(option)

            }




        })

    }

    const handleAboveBelowValid = () => {

        const primaryAbove = Number(filters?.primaryPerAbo || 0);
        const primaryBelow = Number(filters?.primaryPErBel || 0);
        const secondaryAbove = Number(filters?.secoundryPersonlityAbo || 0);
        const secondaryBelow = Number(filters?.secoundryPersonlityBel || 0);
        const expAbove = Number(filters?.expAbo || 0);
        const expBelow = Number(filters?.expBel || 0);


        if (
            (filters?.primaryPerAbo && filters?.primaryPErBel && primaryBelow < primaryAbove) ||
            (filters?.secoundryPersonlityAbo && filters?.secoundryPersonlityBel && secondaryBelow < secondaryAbove) ||
            (filters?.expAbo && filters?.expBel && expBelow <= expAbove)
        ) {
            toastMsg('error', 'Please Enter Below Value Greater Than Above');
            return false;
        }

        return true;
    };



    return (
        <>
            <Modal show={show}
                centered
                onHide={() => {
                    setShowAdvanceFilter(false)
                    clearFilters()
                }}
                size="lg"
            >
                <Modal.Header closeButton className="custom-close-btn">
                    <h6 className="mb-0 mt-1">Advanced Filter</h6>
                </Modal.Header>
                <Modal.Body style={{ minHeight: '400px', maxHeight: '600px', overflow: 'scroll', overflowX: 'hidden' }}>
                    <Form>

                        <Form.Group className="row align-items-center mb-2">
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Filter Name</Form.Label>

                            <div className="col-md-9">
                                <CustomSelect
                                    value={filters?.id}
                                    isBottomBorder={true}
                                    options={filterList}
                                    labelKey='label'
                                    valKey='value'
                                    // isMulti={true}
                                    size={"small"}
                                    placeholder="Filter Name"
                                    handleChange={(e, data) => {


                                        setFilters(JSON.parse(data?.details?.details?.filterJson) || {})

                                        setFilters(prev => ({
                                            ...prev,
                                            id: e
                                        }))

                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Personality Match</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    value={filters?.personalityMatch}
                                    isBottomBorder={true}
                                    options={personalityTypes}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Personality Match"
                                    handleChange={(e) => {
                                        handleChange('personalityMatch', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>

                        <Form.Group className="row align-items-center mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Education Level</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={educationOptions}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Education Level"
                                    value={filters?.educationLevels}
                                    handleChange={(e) => {
                                        handleChange('educationLevels', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Education Area</Form.Label>
                            <div className="col-md-9">
                                {/* <div className="d-flex flex-row flex-wrap align-items-center gap-2">
                                    {filters?.educationArea?.map((i, index) => (
                                        <div
                                            key={index}
                                            className="chips d-inline-flex font-size-13px"
                                        >
                                            {i} <span className="ms-1 fw-bolder" style={{ fontSize: '18px' }}
                                                onClick={() => handleRemove(index, 'educationArea')}
                                            >
                                                ×</span>
                                        </div>
                                    ))}
                                </div> */}
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData?.eductionArea}
                                    labelKey='specializationName'
                                    valKey='specializationName'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Education Area"
                                    value={filters?.educationArea}
                                    handleChange={(e) => {
                                        handleChange('educationArea', e)
                                    }}
                                    isClearaAble={false}
                                />
                                {/* <Form.Control
                                    type="text"
                                    placeholder="Press Enter To Add"
                                    className="bottomBorderField"
                                    value={searchTermsVal?.educationAreaVal}
                                    onChange={(e) => setsearchTermsVal(prev => ({
                                        ...prev,
                                        educationAreaVal: e.target.value
                                    }))}
                                    onKeyDown={(e) => handleKeyDown(e, 'educationArea', 'educationAreaVal')}

                                /> */}


                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Industry</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.industries}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    placeholder="Industry"

                                    size={"small"}
                                    value={filters?.industry}
                                    handleChange={(e) => {
                                        handleChange('industry', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Current Title</Form.Label>
                            <div className="col-md-9" >
                                {
                                    filters?.currentTitle?.length ?

                                        <div className=" css-hq12ga" >
                                            <div className="d-flex flex-row flex-wrap align-items-center gap-2" style={{ marginLeft: '0px' }}>
                                                {filters?.currentTitle?.map((i, index) => (
                                                    <div
                                                        key={index}
                                                        className="maidBAr"
                                                    >
                                                        <div className="manBarText" style={{ fontSize: "12px" }}>{i}</div>
                                                        <div className="mainBarIcon" onClick={() => handleRemove(index, 'currentTitle')}>
                                                            <img src={cross} />
                                                        </div>

                                                    </div>
                                                ))}
                                            </div>



                                        </div> : null
                                }
                                <Form.Control
                                    type="text"
                                    placeholder="Press Enter To Add"
                                    className="bottomBorderField custom-placeholder"
                                    value={searchTermsVal?.currentTitleVal}

                                    onChange={(e) => setsearchTermsVal(prev => ({
                                        ...prev,
                                        currentTitleVal: e.target.value
                                    }))}
                                    onKeyDown={(e) => handleKeyDown(e, 'currentTitle', 'currentTitleVal')}

                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2">
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Experience</Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                {/* Above Label */}
                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Above</Form.Label>
                                </div>

                                {/* Above Input */}
                                <div className="col-md-2">
                                    <Form.Control
                                        style={{ width: "100%" }}
                                        type="number"
                                        value={filters?.expAbo}
                                        className="bottomBorderField col-md-8"
                                        onChange={(e) => handleChange("expAbo", e.target.value)}
                                    />
                                </div>

                                {/* Year Label (After Above) */}
                                <div className="col-md-1">
                                    <span className="job_size col-md-3 mb-0 font-size-13px">Year</span>
                                </div>

                                {/* Below Label */}
                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Below</Form.Label>
                                </div>

                                {/* Below Input */}
                                <div className="col-md-2">
                                    <Form.Control
                                        style={{ width: "100%" }}
                                        type="number"
                                        value={filters?.expBel}
                                        className={`bottomBorderField col-md-8 ${filters?.expAbo && filters?.expBel && Number(filters.expAbo) > Number(filters.expBel)
                                            ? 'bottomBorderFieldInvalid'
                                            : ''
                                            }`}
                                        onChange={(e) => handleChange("expBel", e.target.value)}
                                    />
                                </div>

                                {/* Year Label (After Below) */}
                                <div className="col-md-1">
                                    <span className="job_size col-md-3 mb-0 font-size-13px">Year</span>
                                </div>

                                {/* Cross Icon at End of Row */}
                                {(filters?.expAbo || filters?.expBel) && (
                                    <div className="col-md-4 d-flex justify-content-end" style={{ marginLeft: '-10px' }}>
                                        <img
                                            src={clear} // your cross icon
                                            alt="Clear"
                                            style={{
                                                height: "18px",
                                                width: "18px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() =>
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    expAbo: '',
                                                    expBel: '',
                                                }))
                                            }
                                        />
                                    </div>
                                )}
                            </div>

                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Department</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.departments}
                                    labelKey='name'
                                    valKey='name'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Department"
                                    value={filters?.departments}
                                    handleChange={(e) => {
                                        handleChange('departments', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Salary Expectation</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData?.salOpt}
                                    labelKey='label'
                                    valKey='value'
                                    isMulti={true}
                                    size={"small"}
                                    placeholder="Salary Expectation"
                                    value={filters?.expectedSal}
                                    handleChange={(e) => {
                                        handleChange('expectedSal', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Available Before</Form.Label>
                            <div className="col-md-9 position-relative">
                                {/* Date Input */}
                                <Form.Control
                                    type="date"
                                    placeholder="Available Before"
                                    className="bottomBorderField pe-4"
                                    style={{ paddingRight: "35px" }} // Add space for the clear icon
                                    value={filters?.availDateBef || ""}
                                    onChange={(e) => handleChange("availDateBef", e.target.value)}
                                />

                                {/* Clear Icon on the Right */}
                                {filters?.availDateBef && (
                                    <img
                                        src={clear} // Your clear icon image
                                        alt="Clear"
                                        className="position-absolute top-50 translate-middle-y"
                                        style={{
                                            right: "22px",         // Position at the right side
                                            cursor: "pointer",
                                            width: "16px",
                                            height: "16px",
                                            zIndex: 2
                                        }}
                                        onClick={() => handleChange("availDateBef", "")} // Clear the value
                                    />
                                )}
                            </div>


                        </Form.Group>
                        {
                            customQuestion?.map((i, index) => {
                                if (!i?.questionText) return null;
                                let key = "question" + (index + 1);

                                return (
                                    <Form.Group key={index} className="row align-items-center mb-2">
                                        <div className="col-md-3">
                                            <Tooltip title={i?.questionText} placement="top">
                                                <Form.Label className="job_size mb-0 font-size-13px">
                                                    Custom Question {index + 1}
                                                </Form.Label>
                                            </Tooltip>
                                        </div>

                                        <div className="col-md-9 d-flex align-items-center justify-content-between" >
                                            <div>
                                                {["Yes", "No"].map((option) => (
                                                    <Form.Check
                                                        inline
                                                        key={option}
                                                        type="radio"
                                                        id={`${key}-${option}`}
                                                        name={key}
                                                        label={option}
                                                        value={option}
                                                        className="me-3 font-size-13px"
                                                        checked={filters[key] === option}
                                                        onChange={(e) => handleChange(key, e.target.value === filters[key] ? "" : e.target.value)}
                                                    />
                                                ))}
                                            </div>
                                            {
                                                filters[key] &&

                                                <div className="col-md-5 d-flex justify-content-end" style={{ paddingRight: '12px' }}>
                                                    <img src={clear} style={{ height: '16px', width: '16px', marginTop: '-7px' }}
                                                        onClick={() => handleChange(key, '')}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </Form.Group>
                                );
                            })
                        }
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Primary Personality</Form.Label>

                            <div className="col-md-9 d-flex align-items-center">
                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Above</Form.Label>
                                </div>
                                <div className="col-md-2">
                                    <Form.Control
                                        style={{ width: '100%' }}
                                        type='number'
                                        value={filters?.primaryPerAbo}

                                        className="bottomBorderField col-md-8"
                                        onChange={(e) => {
                                            if (e.target.value <= 100)
                                                handleChange('primaryPerAbo', e.target.value)
                                        }}
                                    />


                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0 font-size-13px"
                                    >
                                        %
                                    </span>
                                </div>

                                <div className="col-md-1" style={{ marginLeft: '-25px' }}>
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Below</Form.Label>
                                </div>
                                <div className="col-md-2">
                                    <div style={{ position: "relative", width: "100%" }}>
                                        <Form.Control
                                            style={{ width: "100%", paddingRight: "25px" }} // padding-right so text doesn't overlap with %
                                            type="number"
                                            value={filters?.primaryPErBel}
                                            className={`bottomBorderField col-md-8 ${filters?.primaryPerAbo && filters?.primaryPErBel && Number(filters.primaryPerAbo) > Number(filters.primaryPErBel)
                                                ? 'bottomBorderFieldInvalid'
                                                : ''
                                                }`}

                                            onChange={(e) => {
                                                if (e.target.value <= 100) handleChange("primaryPErBel", e.target.value)
                                            }}
                                        />


                                    </div>

                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0 font-size-13px"
                                    >
                                        %
                                    </span>
                                </div>
                                <div className="col-md-4 d-flex justify-content-end" style={{ marginLeft: '13px' }}>
                                    {
                                        (filters?.primaryPerAbo || filters?.primaryPErBel) &&
                                        <img
                                            src={clear}
                                            alt="Clear"
                                            style={{

                                                height: "15px",
                                                width: "15px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() =>
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    primaryPerAbo: '',
                                                    primaryPErBel: "",
                                                }))
                                            }
                                        />
                                    }
                                </div>
                                {/* <Form.Control
                                    type="text"
                                    placeholder={filters?.prmeryIn == 'Between' ? 'Ex 80-90' : "Primary Personality"}
                                    className="bottomBorderField"
                                    value={filters?.primaryPersonlity}
                                    onChange={(e) => handleChange('primaryPersonlity', e.target.value)}
                                /> */}
                            </div>
                        </Form.Group>
                        <Form.Group className="row align-items-center mb-2" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">
                                Secondary Personality</Form.Label>
                            <div className="col-md-9 d-flex align-items-center">
                                <div className="col-md-1">
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Above</Form.Label>
                                </div>
                                <div className="col-md-2">
                                    <div>
                                        <Form.Control
                                            style={{ width: '100%' }}
                                            type='number'
                                            value={filters?.secoundryPersonlityAbo}

                                            className="bottomBorderField col-md-8"
                                            onChange={(e) => {
                                                if (e.target.value <= 100) handleChange('secoundryPersonlityAbo', e.target.value)
                                            }
                                            }
                                        />


                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0 font-size-13px"
                                    >
                                        %
                                    </span>
                                </div>
                                <div className="col-md-1" style={{ marginLeft: '-25px' }}>
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Below</Form.Label>
                                </div>
                                <div className="col-md-2">

                                    <div style={{ position: "relative", width: "100%" }}>
                                        <Form.Control
                                            style={{ width: '100%' }}
                                            type='number'
                                            value={filters?.secoundryPersonlityBel}

                                            className={`bottomBorderField col-md-8 ${filters?.secoundryPersonlityBel && filters?.secoundryPersonlityAbo && Number(filters.secoundryPersonlityAbo) > Number(filters.secoundryPersonlityBel)
                                                ? 'bottomBorderFieldInvalid'
                                                : ''
                                                }`}
                                            onChange={(e) => {
                                                if (e.target.value <= 100) handleChange('secoundryPersonlityBel', e.target.value)
                                            }
                                            }
                                        />


                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <span
                                        className="job_size col-md-3 mb-0 font-size-13px"
                                    >
                                        %
                                    </span>
                                </div>
                                <div className="col-md-4 d-flex justify-content-end" style={{ marginLeft: '13px' }}>
                                    {
                                        (filters?.secoundryPersonlityBel || filters?.secoundryPersonlityAbo) &&
                                        <img
                                            src={clear}
                                            alt="Clear"
                                            style={{

                                                height: "15px",
                                                width: "15px",
                                                cursor: "pointer",
                                            }}
                                            onClick={() =>
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    secoundryPersonlityBel: '',
                                                    secoundryPersonlityAbo: "",
                                                }))
                                            }
                                        />
                                    }
                                </div>

                                {/* <Form.Control
                                    type="text"
                                    className="bottomBorderField"
                                    value={filters?.secoundryPersonlity}
                                    placeholder={filters?.secnIn == 'Between' ? 'Ex 80-90' : "Secondary Personality"}
                                    onChange={(e) => handleChange('secoundryPersonlity', e.target.value)}
                                /> */}
                            </div>
                        </Form.Group>

                        {
                            ['Graph 1', 'Graph 2', 'Graph 3']?.map((graph, index) => {

                                let key = 'graph' + (index + 1)

                                console.log(key);

                                return <Form.Group className="row align-items-center mb-2" controlId="exampleForm.ControlInput1">
                                    <Form.Label className="job_size col-md-3 mb-0 font-size-13px">{graph}</Form.Label>
                                    <div className="col-md-9 ">
                                        <CustomSelect
                                            isBottomBorder={true}
                                            options={personaloities}
                                            labelKey='label'
                                            valKey='label'
                                            placeholder={graph}
                                            isMulti={true}
                                            size={"small"}

                                            value={filters[key]}
                                            handleChange={(e) => {
                                                handleChange(key, e)
                                            }}
                                            isClearaAble={false}
                                        />
                                    </div>
                                </Form.Group>
                            })
                        }



                        <Form.Group className="row align-items-center mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">
                                Quiz Score</Form.Label>
                            <div className="col-md-9">
                                <CustomSelect
                                    isBottomBorder={true}
                                    options={dropdownData.quizScores}
                                    labelKey='label'
                                    valKey='value'
                                    placeholder={"Quiz Score"}
                                    isMulti={true}
                                    size={"small"}
                                    value={filters?.quizScore}
                                    handleChange={(e) => {
                                        handleChange('quizScore', e)
                                    }}
                                    isClearaAble={false}
                                />

                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <CustomButton
                        title='Clear All'
                        buttonType='tertiory'
                        handleClick={
                            clearFilters}
                    />
                    <CustomButton
                        title='Save'
                        buttonType='secondary'
                        handleClick={() => { if (handleAboveBelowValid()) setISAddFilter(true) }}
                    />
                    <CustomButton
                        title='Apply'
                        handleClick={() => {
                            if (handleAboveBelowValid()) {
                                setIsFilter(true)
                                let list = filterApplicant(applicatnts, filters)

                                setAccessCoeList(list)
                                setShowAdvanceFilter(false)
                            }
                        }}

                    />
                </Modal.Footer>
            </Modal>

            <Modal show={isAddFilter}
                centered
                onHide={() => {
                    setISAddFilter(false)
                }}
                size="md"
            >
                <Modal.Header closeButton className="custom-close-btn">
                    <h6 className="mb-0 mt-1">Add Update Filter </h6>
                </Modal.Header>
                <Modal.Body >
                    <Form>
                        <Form.Group className="" >
                            <Form.Label className="job_size col-md-3 mb-0 font-size-13px">Add Filter Name</Form.Label>


                            <Form.Control
                                type="text"
                                placeholder='Add Filter Name'
                                className="input-text-14"
                                value={filterName}
                                onChange={(e) => setFilterName(e.target.value)}


                            />

                        </Form.Group>

                        <div className="d-flex mt-3 justify-content-end">

                            <div className="d-flex gap-1" >
                                <CustomButton
                                    title={"Cancel"}
                                    buttonType='tertioary'
                                    handleClick={(e) => setISAddFilter(false)}

                                />
                                <CustomButton
                                    title={"Save"}
                                    handleClick={() => handleSaveFilter(true)}
                                />
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

        </>
    )

}


export default AdvanceFilter